<template>
	<div class="full" v-loading="loading">
		<vxe-grid ref="initoutputinvoiceorderTable" v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
		<invoiceConfig ref="invoiceConfig" :invoicedata="invoicedata" :tab="tab" @modalhide="invoiceConfigHide" />
		<editcargo-Form ref="editcargoForm" :goodsUids="goodsUids" :currentrow="currentrow" @submit="editcargoSubmit" />
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import invoiceConfig from '../../invoice/index.vue'
	import editcargoForm from '../../goodsspu/editcargo.vue'
	export default {
		mixins: [listMixins],
		props: {
			date: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				step: 1,
				invoicedata:[],
				tab:[],
				goodsUids:[],
				currentrow:null,
				modal_model: true,
				modal_title: '生成亿企赢单据',
				modal_width: 1200,
				modal_height: 800,
				list_footerField:[
					{field:'price',toFixed:6},
					{field:'taxprice',toFixed:6},
					{field:'totalPrice',toFixed:6},
				],
				loading:false
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			sourcefile(row) {
				this.invoicedata = {
					invoiceNumber:row.invoiceNumber,
					customerId:row.customerId,
					invoiceId:row.invoiceId,
					orderId:row.orderId,
					orderPlant:row.orderPlant,
					invoiceType:1
				}
				this.tab = ['invoice','detail']
				this.$nextTick(()=>{
					this.$refs.invoiceConfig.modal_show()
				})
			},
			invoiceConfigHide(){
				this.customreload()
			},
			cargoconfig(row){
				if(row.ismatch!=1){
					this.$message.error('未关联商品无法配置')
					return
				}
				this.currentrow = row
				this.goodsUids = [row.goodsUid]
				this.$nextTick(()=>{
					this.$refs.editcargoForm.modal_show()
				})
			},
			editcargoSubmit(){
				this.customreload()
			},
			list_beforeCreateGrid(gridOptions){
				gridOptions.toolbarConfig.buttons = [{
					name: '导出',
					status: 'success',
					code: 'export'
				},{
					name: '自动关联存货',
					status: 'primary',
					code: 'autorelationinventory'
				}]
				gridOptions.columns = [{
						type: 'seq',
						title: '#',
						width:50
					},{
						field: 'customerName',
						title: '开票公司',
					},
					{
						field: 'invoiceNumber',
						title: '发票号',
					},
					{
						field: 'cargoName',
						title: '存货名称',
						sortable:true,
					},
					{
						field: 'spec',
						title: '规格型号',
					},
					{
						field: 'taxItemName',
						title: '类型',
					},
					
					{
						field: 'amount',
						title: '数量',
					},
					{
						field: 'unitPrice',
						title: '单价',
					},
					{
						field: 'price',
						title: '不含税金额',
					},
					{
						field: 'taxprice',
						title: '税额',
					},
					{
						field: 'unit',
						title: '单位',
					},
					{
						field: 'taxRateWithPercent',
						title: '税率',
					},

					{
						field: 'totalPrice',
						title: '价税合计',
					},
					{
						field: 'ismatch',
						title: '关联状态',
						sortable:true,
						slots: {
							default: ({row}) => {
								if(row.ismatch == 0){
									return [
										<span style="color:#F56C6C" type = "text" size = "mini">未关联</span>,
									]
								}
								if(row.ismatch == 1){
									return [
										<span style="color:#67C23A" type = "text" size = "mini">已关联</span>,
									]
								}																				
							}
						}						
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 100,
						slots: {
							default: ({row}) => {
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.sourcefile(row)}}>原件</el-button>,
									<el-button type = "text" size = "mini" onClick = {() => {this.cargoconfig(row)}}>存货</el-button>
									
								]
							}
						}
					}
				]
				gridOptions.formConfig = false
			},
			autorelationinventory(){
					let data = this.$refs.initoutputinvoiceorderTable.getTableData().fullData
					data = data.filter((item)=>{
						return !item.cargoName && item.goodsUid
					})
					data = data.map((item)=>{
						let cargo = item.invoicedetailcargoName.replace(/^\*+|\*+$/g, '') 
						cargo = cargo.split('*')
						return {
							cargoname:cargo[1],
							cargotype:window.systemMethods.getEmunId('cargotype',cargo[0]),
							goodsName:item.goodsName,
							goodsUids:[item.goodsUid]
						}
					})	
					data = data.filter((item)=>{
						return item.cargotype
					})
					
					let promiseArr = data.map((item) =>{
						return this.$api.goods.updategoodsspu(item)
					})
					this.loading = true
					Promise.all(promiseArr).then(()=>{
						this.loading = false
						this.customreload()
					},()=>{
						this.loading = false
					})
				
				
			},
			list() {
				return new Promise((resolve) => {
					let date = new Date(this.date).getTime()
					if(date){
						this.$api.invoice.initoutputinvoiceorder({
							date: date / 1000,
							action: 'init'
						}).then((res) => {
							resolve(res)
						},()=>{
							this.loading = false
						})
					}else{
						resolve({
							list:[]
						})
					}
				})
			},
			valid(){
				let data = this.$refs.initoutputinvoiceorderTable.getTableData().fullData
				let cargoNameBuff = false
				for(let i =0 ;i<data.length;i++){
					if(!data[i].cargoName){
						cargoNameBuff = data[i]
						break;
					}
				}
				if(cargoNameBuff){
					this.$refs.initoutputinvoiceorderTable.scrollToRow(cargoNameBuff)
				}
				return cargoNameBuff
			},
			submit() {

				//this.init()
			},
			reset() {
				//this.init()
			},
			customreload() {
				this.$refs.initoutputinvoiceorderTable.commitProxy('query')
			},
		},
		components: {
			invoiceConfig,
			editcargoForm
		}
	}
</script>